"use strict";

import BinaryButtonInteractionView from "/js/interaction-views/binary-button-interaction-view.js";
import QuestionnaireInteractionView from "/js/interaction-views/questionnaire-interaction-view.js";
import DragDropInteractionView from "/js/interaction-views/dragdrop-interaction-view.js";
import MultipleChoiceInteractionView from "/js/interaction-views/multiple-choice-interaction-view.js";
import ThisThatInteractionView from "/js/interaction-views/this-that-interaction-view.js";
import ChecklistInteractionView from "/js/interaction-views/checklist-interaction-view.js";
import UnsupportedInteractionView from "/js/interaction-views/unsupported-interaction-view.js";

export default class InteractionViewUtil {

  /** 
   * Instantiates the appropriate interaction view subclass based on passed-in the interaction json 
   * node.
   */ 
  static makeInteractionView(interactionJson, initialAnswers=null) {

    if (initialAnswers != null && (initialAnswers.interactionId !== interactionJson.interactionId)) {
      clw("WARNING: id mismatch points to logic error, will ignore any initialAnswers: ",
          interactionJson.interactionId, initialAnswers.interactionId);
      initialAnswers = null;
    }

    let view;
    switch (interactionJson.template) {
      case "binary-button":
        view = new BinaryButtonInteractionView(interactionJson);
        break;
      case "questionnaire":
        view = new QuestionnaireInteractionView(interactionJson, initialAnswers);
        break;
      case "drag-and-drop":
        view = new DragDropInteractionView(interactionJson);
        break;
      case "multiple-choice":
        // fall through
      case "multiple-image":
        view = new MultipleChoiceInteractionView(interactionJson);
        break;
      case "this-or-that":
        view = new ThisThatInteractionView(interactionJson);
        break;
      case "list-maker":
        view = new ChecklistInteractionView(interactionJson, initialAnswers);
        break;
      default:
        clw("WARNING: Bad interactionJson for interaction", interactionJson);
        view = new UnsupportedInteractionView(interactionJson);
        break;
    }
    return view;
  }  
}